import type { StoreApi } from "zustand";
import type { TChatStore } from "../chat-store.types";
import type { TMessage } from "./message.types";
import { newMessageInitialState } from "./message.initial-state";

type TSetState = StoreApi<TChatStore>["setState"];

export const createNewMessageActions = (set: TSetState) => ({
  setNewMessageFulfilled: ({
    messages,
    chatId,
    chatType,
    itsMyMessage,
  }: {
    messages: TMessage[];
    chatId: string;
    chatType: string;
    itsMyMessage: boolean;
  }) =>
    set(() => ({
      newMessage: {
        ...newMessageInitialState,
        fetched: true,
        source: messages.map((message) => ({
          ...message,
          itsMyMessage,
        })),
        chatId,
        itsMyMessage,
        chatType,
      },
    })),

  setNewMessageRejected: (source: TMessage[]) =>
    set((state) => ({
      newMessage: { ...state.newMessage, fetched: false, error: true, source },
    })),

  resetNewMessage: () => set(() => ({ newMessage: newMessageInitialState })),
});
